export default __webpack_public_path__ + "static/media/Archpriest's Threads of the Underworld.4377086c.jpg";